import axios from "~/plugins/axios";

const baseUrl = "/web_api/v1/automation_result";

export default {
  paginate(
    page = 1,
    perPage = 15,
    includes = [
      "customer",
      "processed_by",
    ],
  ) {
    return axios.get(`${baseUrl}`, {
      params: {
        page,
        perPage,
        includes,
      },
    })
      .then((response) => response.data);
  },
  paginateByAutomation(
    automationId,
    page = 1,
    perPage = 15,
    name = "",
    includes = [
      "customer",
      "processed_by_user",
      "ignored_by_user",
    ],
  ) {
    return axios.get(`${baseUrl}/by_automation/${automationId}`, {
      params: {
        page,
        perPage,
        includes,
        by_name: name,
      },
    })
      .then((response) => response.data);
  },
  paginateByGlobalAutomationConfiguration(
    globalAutomationConfigurationId,
    page = 1,
    perPage = 15,
    name = "",
    includes = [
      "customer",
      "processed_by_user",
      "ignored_by_user",
    ],
  ) {
    return axios.get(`${baseUrl}/by_global_automation_configuration/${globalAutomationConfigurationId}`, {
      params: {
        page,
        perPage,
        includes,
        by_name: name,
      },
    })
      .then((response) => response.data);
  },
  processByUser(automationResultId, userId) {
    return axios
      .post(`${baseUrl}/${automationResultId}/process`, { user_id: userId })
      .then((response) => response.data);
  },
  ignoreByUser(automationResultId, userId) {
    return axios
      .post(`${baseUrl}/${automationResultId}/ignore`, { user_id: userId })
      .then((response) => response.data);
  },
  processAllByUser(automationResultIds, userId) {
    return axios
      .post(`${baseUrl}/process_all`, {
        automation_result_ids: automationResultIds,
        user_id: userId,
      })
      .then((response) => response.data);
  },
  ignoreAllByUser(automationResultIds, userId) {
    return axios
      .post(`${baseUrl}/ignore_all`, {
        automation_result_ids: automationResultIds,
        user_id: userId,
      })
      .then((response) => response.data);
  },
  ignoreUnprocessedByGlobalAutomationConfiguration(globalAutomationConfigurationId, userId) {
    return axios
      .post(
        `${baseUrl}/ignore_unprocessed_by_global_automation_configuration/${globalAutomationConfigurationId}`,
        { user_id: userId },
      ).then((response) => response.data);
  },
  ignoreUnprocessedByAutomation(automationId, userId) {
    return axios
      .post(`${baseUrl}/ignore_unprocessed_by_automation/${automationId}`, { user_id: userId })
      .then((response) => response.data);
  },
  processUnprocessedByAutomation(automationId, userId) {
    return axios
      .post(`${baseUrl}/process_unprocessed_by_automation/${automationId}`, { user_id: userId })
      .then((response) => response.data);
  },
  processUnprocessedByGlobalAutomationConfiguration(automationConfigurationId, userId) {
    return axios
      .post(`${baseUrl}/process_unprocessed_by_global_automation_configuration/${automationConfigurationId}`, { user_id: userId })
      .then((response) => response.data);
  },
  paginateUnprocessedByGlobalAutomationConfiguration(
    globalAutomationConfigurationId,
    page = 1,
    perPage = 15,
    name = "",
    includes = [
      "customer",
      "processed_by_user",
      "ignored_by_user",
    ],
  ) {
    return axios.get(`${baseUrl}/by_global_automation_configuration/${globalAutomationConfigurationId}/unprocessed`, {
      params: {
        page,
        perPage,
        includes,
        by_name: name,
      },
    }).then((response) => response.data);
  },
  paginateUnprocessedByAutomation(
    automationId,
    page = 1,
    perPage = 15,
    name = "",
    includes = [
      "customer",
      "processed_by_user",
      "ignored_by_user",
    ],
  ) {
    return axios.get(`${baseUrl}/by_automation/${automationId}/unprocessed`, {
      params: {
        page,
        perPage,
        includes,
        by_name: name,
      },
    })
      .then((response) => response.data);
  },
  skipForAutomation(automationId) {
    return axios.post(`${baseUrl}/skip_for_automation/${automationId}`)
      .then((response) => response.data);
  },
  skipForGlobalAutomationConfiguration(globalAutomationConfigurationId) {
    return axios.post(`${baseUrl}/skip_for_global_automation_configuration/${globalAutomationConfigurationId}`)
      .then((response) => response.data);
  },
};
